import { API_BASE } from '../config/api';

const handleResponse = async (response, fallbackMessage = 'Unable to load team players.') => {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = data.error || data.message || fallbackMessage;
    throw new Error(message);
  }

  return data;
};

export const fetchTeamPlayers = async (token) => {
  const response = await fetch(`${API_BASE}/api/teams/players`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response);
};

export const updateTeamPlayerStatus = async (playerId, action, token) => {
  const response = await fetch(`${API_BASE}/api/teams/players/${playerId}/approval`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ action }),
  });

  return handleResponse(response, 'Unable to update player status.');
};

export const removeTeamPlayer = async (playerId, token) => {
  const response = await fetch(`${API_BASE}/api/teams/players/${playerId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to remove player right now.');
};

export const updateTeamPlayerRoles = async (playerId, roles, token) => {
  const response = await fetch(`${API_BASE}/api/teams/players/${playerId}/roles`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ roles }),
  });

  return handleResponse(response, 'Unable to update team roles right now.');
};
